import React from 'react'
import { withGridContext } from '../providers'
import { ContextType } from '../types/advanced-grid.types'
import ButtonsPager from './ButtonsPager'
import PagesControl from './PagesControl'

/**
 * Component to render the pagination
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param param0
 * @returns
 */
const PageRenderer: React.FC<ContextType> = ({ maxPages, pages, gridId }) => {
    const shouldRenderButtons = pages && maxPages && pages <= maxPages
    if (!pages || pages === 0) {
        return null
    }
    return (
        <div
            className="btn-toolbar flex justify-end min-w-80"
            role="toolbar"
            aria-label="Toolbar with button groups"
        >
            {shouldRenderButtons ? (
                <ButtonsPager pages={pages || 0} gridId={gridId || 'grid'} />
            ) : (
                <PagesControl />
            )}
        </div>
    )
}

PageRenderer.defaultProps = {
    maxPages: 0,
    pages: 0
}

export default withGridContext(PageRenderer)
